import { Breadcrumbs, Skeleton, Typography } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";

function UpdatePageLoader({ mode = "update" }) {
  const title = mode === "add" ? "Add Vehicle" : "Update Vehicle";

  return (
    <div className="vehicle-form-page">
      <Breadcrumbs aria-label="breadcrumb" className="mb-3">
        <Link to="/">Home</Link>
        <Link to="/vehicles">Vehicles</Link>
        <Typography>{title}</Typography>
      </Breadcrumbs>

      <Skeleton variant="rounded" height={120} sx={{ borderRadius: "16px", mb: 2 }} />

      <div className="section vf-section">
        <div className="vf-basic-grid">
          <Skeleton variant="rounded" height={220} />
          <div className="vf-fields-grid">
            {Array.from({ length: 6 }).map((_, idx) => (
              <Skeleton key={idx} variant="rounded" height={64} />
            ))}
          </div>
        </div>
      </div>

      <div className="section vf-section">
        <Skeleton variant="rounded" height={28} width={220} sx={{ mb: 2 }} />
        <div className="vf-fields-grid">
          {Array.from({ length: 6 }).map((_, idx) => (
            <Skeleton key={idx} variant="rounded" height={64} />
          ))}
        </div>
      </div>
    </div>
  );
}

export default UpdatePageLoader;
